// Tells Sentry when the 3D fails. By hand, as the SDK would add its weight to every visit for the few that fail, and
// sendBeacon, as it survives the reload that follows. No cookies; the project stores no IPs and takes reports from this
// host alone. `kind` says how the page went on: "retried", "failed" or "no-webgl".
const HOST = "vitorenina.com.br";
const KEY = "c22ec87d80b9afa77ba49ea5bf369330";
const INGEST = `https://o35245.ingest.us.sentry.io/api/4512357038882816/envelope/?sentry_key=${KEY}&sentry_version=7`;

export function report(kind, error, gpu = "") {
  if (location.hostname !== HOST) return;
  try {
    const id = Array.from(crypto.getRandomValues(new Uint8Array(16)), (byte) => byte.toString(16).padStart(2, "0")).join("");
    const event = {
      event_id: id,
      timestamp: Date.now() / 1000,
      platform: "javascript",
      level: kind === "retried" ? "warning" : "error",
      release: document.querySelector('script[src*="?v="]')?.src.split("?v=")[1],
      request: { url: location.href, headers: { "User-Agent": navigator.userAgent } },
      exception: { values: [{ type: error.name, value: error.message }] },
      tags: {
        kind,
        gpu: gpu.slice(0, 200),
        navigation: performance.getEntriesByType("navigation")[0]?.type,
        worker: String(!!navigator.serviceWorker?.controller),
        online: String(navigator.onLine),
      },
      extra: { stack: error.stack },
    };
    const envelope = [{ event_id: id, sent_at: new Date().toISOString() }, { type: "event" }, event];
    navigator.sendBeacon(INGEST, envelope.map((line) => JSON.stringify(line)).join("\n"));
  } catch (failure) {
    console.warn("No report:", failure);
  }
}
